import { Suspense } from 'react';
import noop from 'lodash/noop';

import { Dialog } from '@lyearn/ui';
import Loader from '@/components/Loader';
import dynamic from '@/utils/dynamic';

import { AssignmentCreatorPageProps } from '../../views/AssignmentCreator/type';
import { EDITOR_MODAL_CLASSES } from './styles';

const AssignmentCreator = dynamic(
  () => import(/* webpackChunkName: "assignment-creator" */ '../../views/AssignmentCreator'),
);

const AssignmentCreatorModal = (props: AssignmentCreatorPageProps) => {
  const { mode, assignmentId, initialContents, onSuccess, onBack, isInModal } = props;

  return (
    <Dialog open classes={EDITOR_MODAL_CLASSES} onClose={noop}>
      <Suspense fallback={<Loader />}>
        <AssignmentCreator
          assignmentId={assignmentId}
          initialContents={initialContents}
          isInModal={isInModal}
          mode={mode}
          onBack={onBack}
          onSuccess={onSuccess}
        />
      </Suspense>
    </Dialog>
  );
};

export default AssignmentCreatorModal;
